import LoginComponent from '../login-component';
import FormActions from '../../logic/form-actions';
import LoginInput from '../ui-elements/login-input';

import {localize} from '../../infrastructure/localization';

export default class EmailInput extends LoginComponent {

    constructor(props) {
        super(props);
    }

    get error() {
        return this.state.loginModel.validation.errors.email;
    }

    render () {
        return (
            <LoginInput
                componentId={this.state.componentId}
                id="login-email"
                type="text"
                iconId="e-mail"
                value={this.state.loginModel.email}
                label={localize('form-components.email')}
                maxLength={71}
                onFocus={(e) => FormActions.startEditEmail(this.state.componentId)}
                onBlur={(e) => FormActions.endEditEmail(this.state.componentId)}
                onChange={(e) => FormActions.changeEmail(this.state.componentId, e.target.value)}
                error={this.error} />
        )
    }
};


/** WEBPACK FOOTER **
 ** ./src/components/form-components/email-input.jsx
 **/